import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core'

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent {
  loading: boolean = false
  
  @ViewChild('loader') loaderRef: ElementRef

  @Input('src') imageUrl: string
  @Input('alt') alternativeText: string = "Image"
  @Input() width: number = 340
  @Input() height: number = 225
  @Input('placeholder') text: string = 'No Image'
  @Input('background') bgColor = '#f7f7f7'

  constructor(
    private renderer: Renderer2
  ) {}

  get encodedText() {
    return encodeURI(this.text)
  }

  get imageStyle(): string {
    return this.loading ? 'hidden' : 'visible'
  }

  get scale(): number {
    return this.width / this.height
  }

  // ngOnChanges() {
  //   this.loading = true
  // }

  // ngAfterViewInit() {
  //   if(window) {
  //     let width = Number(window.getComputedStyle(this.loaderRef.nativeElement)
  //       .width.replace('px', ''))

  //     this.renderer.setStyle(
  //       this.loaderRef.nativeElement, 'height', (width / this.scale) + 'px'
  //     )
  //   }
  // }

  loaded(event) {
    this.loading = false
  }

  placeholder(event) {
    //this.loading = true
    event.target.src = `https://via.placeholder.com/${this.width}x${this.height}/f7f7f7?text=${this.encodedText}`
  }
}
